import { ReactComponent as ListViewIconSvg } from './list-view.svg'
export default ListViewIconSvg
